<template>
  <wishlists :key="favoriteId" :favoriteId="parseInt(favoriteId)"></wishlists>
</template>
<script>
import Wishlists from "./components/Wishlists.vue";

export default {
  name: "AddToFavouritesApp",
  components: {
    Wishlists,
  },
  data() {
    return {
      favoriteId: 0,
    };
  },
  computed: {
    wishlists() {
      return this.$store.state.wishlists;
    }
  },
  mounted() {
    const favoriteIdInput = document.getElementById("favoriteId");
    favoriteIdInput.addEventListener("change", (event) => {
      this.setFavouriteId(favoriteIdInput.value);
    });
    this.init();
  },
  methods: {
    init: function() {
      this.$store.dispatch("getWishlists").then((data) => { 
      });
    },
    setFavouriteId: function(id) {
      this.favoriteId = id;
    },
  },
};
</script>